import { apiClient } from './client';
import { CreateActionRequest, CreateActionResponse } from '@gridwise/shared';

export async function createAction(
  data: CreateActionRequest,
): Promise<CreateActionResponse> {
  const response = await apiClient.post('/actions', data);
  return response.data.data;
}

export async function updateAction(id: string, data: Partial<any>): Promise<any> {
  const response = await apiClient.patch(`/actions/${id}`, data);
  return response.data.data;
}
